export default "__VITE_ASSET__DyUvfvNF__"